import { __assign } from 'tslib';
import React__default, { forwardRef, useRef, useImperativeHandle, useEffect } from 'react';
import classNames from 'classnames';
import videojs from 'video.js';
import { useAnalyticsQueue } from '@invitae/analytics-queue';
import useVideoEvents from '../useVideoEvents.esm.js';
import styles from './NvVideo.module.esm.js';

var NvVideo = forwardRef(function NvVideo(videoModel, ref) {
    var _a, _b, _c, _d;
    var autoplay = videoModel.autoplay, muted = videoModel.muted, showVideoPlayerControls = videoModel.showVideoPlayerControls, asset = videoModel.asset, heading = videoModel.heading, loop = videoModel.loop, thumbnail = videoModel.thumbnail, options = videoModel.options, onReady = videoModel.onReady;
    var logEvent = useAnalyticsQueue().logEvent;
    var videoRef = useRef(null);
    var playerRef = useRef(null);
    useImperativeHandle(ref, function () { return ({
        get player() {
            return playerRef.current;
        },
        get video() {
            return videoRef.current;
        },
    }); }, []);
    var _options = __assign({ autoplay: autoplay ? 'muted' : false, controls: showVideoPlayerControls, fill: false, fluid: true, height: '200px', loop: loop, muted: muted, normalizeAutoplay: Boolean(autoplay), poster: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.fields.asset.fields.file.url, responsive: true, sources: [
            {
                src: "https:".concat((_b = (_a = asset === null || asset === void 0 ? void 0 : asset.fields) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.url),
                type: ((_d = (_c = asset === null || asset === void 0 ? void 0 : asset.fields) === null || _c === void 0 ? void 0 : _c.file) === null || _d === void 0 ? void 0 : _d.contentType) || 'video/mp4',
            },
        ], width: '100%' }, options);
    useEffect(function () {
        var _a;
        window.VIDEOJS_NO_DYNAMIC_STYLE = true;
        logEvent({
            eventName: 'Contentful video loaded',
            eventProperties: {
                currentPage: window.location.pathname,
                videoName: heading,
            },
        });
        if (!playerRef.current) {
            var videoElement = document.createElement('video');
            // Instruct the browser to play the video within the element's playback area,
            // rather than automatically playing in fullscreen mode when autoplay is set to true
            // This attribute is needed for iOS because iOS is special :)
            videoElement.setAttribute('playsinline', '');
            (_a = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _a === void 0 ? void 0 : _a.appendChild(videoElement);
            playerRef.current = videojs(videoElement, _options, onReady);
        }
        else {
            var player = playerRef.current;
            player === null || player === void 0 ? void 0 : player.autoplay(_options.autoplay);
            player === null || player === void 0 ? void 0 : player.src(_options.sources);
        }
    }, [_options, videoRef]);
    useEffect(function () {
        var player = playerRef.current;
        return function () {
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [playerRef]);
    useVideoEvents({ contentfulPlayer: playerRef, options: _options, videoModel: videoModel });
    return (React__default.createElement("div", { className: classNames('video-js', styles['hide-in-percy'], styles.vjsNucleobase), "data-vjs-player": true },
        React__default.createElement("div", { ref: videoRef })));
});

export { NvVideo as default };
//# sourceMappingURL=NvVideo.esm.js.map
